<p *ngIf="!loggedOut()">Just a moment</p>
<p *ngIf="loggedOut()">You have been signed out. You will be redirected to the home page in just a moment.</p>
